import Cookies from 'js-cookie';

const domain = window.location.host;

if (domain.substring(domain.length - 13) === 'fzo-raming.nl') {
  Cookies.remove('XSRF-TOKEN', { domain: '.fzo-raming.nl' });
}
